export default "* Hvilke opgaver eleverne skal arbejde med til hvert kapitel.";